import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser, getHostDetails, getLoggedUserDetails, getLoginLogoutUserStatus, getloginupdatedstatus, getLogoutUserStatus, getUserProfilePic, loadUserDetails, loadUserProfilePic, loginLogoutStatusReceived, loginLogoutUpdateStatus, loginStatusUpdate, logoutCurrentUser, userLogoutStatusRecevied } from "../../store/auth";
import ChangePassword from "../../../components/ChangePassword";
import Help from "../../../components/Anlytics/Help";
import SupportPupup from "../../../components/Anlytics/SupportPupup";
import { useDispatch, useSelector } from "react-redux";
import { getPageTitle, getWorkbenchHelpDocs, loadWorkbenchHelpDocs } from "../../store/layoutUI";
import AddSecurityQuestion from "../../../components/AddSecurityQuestion";
import PartnerProfile from "../../../components/PartnerManage/PartnerProfile";
import config from "../../../config.json";
import { PUBLIC_CLIENT_APPLICATION } from "../../../msalConfig";

const HEADER_STYLES = {
    shell: {
        background: "#ffffff",
        boxShadow: "0 14px 40px rgba(15, 23, 42, 0.08)",
        color: "#0f172a",
        overflow: "visible",
        position: "relative",
        width: "100%",
        borderBottom: "1px solid rgba(203, 213, 225, 0.85)"
    },
    topRow: {
        borderBottom: "1px solid rgba(203, 213, 225, 0.75)",
        position: "relative",
        zIndex: 5
    },
    brandRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "20px",
        marginBottom: "4px",
        flexWrap: "wrap"
    },
    brandLogo: {
        height: "84px",
        width: "auto",
        display: "block",
        backgroundColor: "#ffffff",
        padding: "8px 12px",
        borderRadius: "6px",
    },
    profileCard: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "14px",
        width: "100%",
        minHeight: "84px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
        borderRadius: "18px",
        padding: "12px 14px",
        color: "#0f172a",
        backdropFilter: "blur(6px)",
        overflow: "visible",
        zIndex: 6
    },
    profileMain: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        minWidth: 0,
        flex: 1
    },
    avatar: {
        width: "50px",
        height: "50px",
        objectFit: "cover",
        borderRadius: "50%",
        border: "2px solid rgba(228, 236, 244, 0.45)",
    },
    userContent: {
        minWidth: 0,
        flex: 1
    },
    userName: {
        fontSize: "17px",
        fontWeight: 700,
        lineHeight: 1.2,
        marginBottom: "6px",
        color: "#0f172a"
    },
    detailRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        marginBottom: "5px"
    },
    detailPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 8px",
        borderRadius: "999px",
        backgroundColor: "#eef2f7",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        fontSize: "11px",
        color: "#334155",
        fontWeight: 600,
        lineHeight: 1
    },
    dropdownButton: {
        border: "none",
        background: "#e2e8f0",
        color: "#334155",
        width: "30px",
        height: "30px",
        borderRadius: "999px",
        cursor: "pointer"
    },
    quickRow: {
        background: 'linear-gradient(135deg, rgba(12, 12, 14, 0.9) 0%, rgba(32, 32, 38, 0.9) 50%, rgba(12, 12, 14, 0.9) 100%), url("/assets/Img/slide3.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        borderTop: "1px solid #333",
        zIndex: 1
    },
    quickInfoBlock: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        minHeight: "40px"
    },
    portalBadge: {
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 0.95)",
        backgroundColor: "#eff6ff",
        padding: "8px 14px",
        fontSize: "12px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        color: "#000000",
    },
    quickButton: {
        borderRadius: "999px",
        border: "1px solid rgba(203, 213, 225, 0.95)",
        backgroundColor: "#f8fafc",
        color: "#1e293b",
        padding: "8px 13px",
        fontSize: "13px",
        fontWeight: 600,
        marginTop: "0",
        transition: "background-color 0.2s ease, border-color 0.2s ease"
    },
    logoutButton: {
        borderRadius: "999px",
        border: "1px solid rgba(252, 165, 165, 0.9)",
        backgroundColor: "#fef2f2",
        color: "#b91c1c",
        padding: "8px 13px",
        fontSize: "13px",
        fontWeight: 700,
        marginTop: "0"
    },
    actionWrap: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px"
    },
    dropdownMenu: {
        position: "absolute",
        top: "calc(100% + 10px)",
        right: 0,
        minWidth: "240px",
        backgroundColor: "#f8fbff",
        borderRadius: "14px",
        boxShadow: "0 16px 40px rgba(22, 35, 63, 0.2)",
        padding: "8px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        zIndex: 1000
    },
    dropdownItem: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        width: "100%",
        border: "none",
        background: "transparent",
        color: "#1e293b",
        textAlign: "left",
        padding: "10px 12px",
        borderRadius: "10px",
        fontSize: "14px",
        fontWeight: 600
    },
    toggleButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "36px",
        height: "36px",
        borderRadius: "8px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "#f8fafc",
        color: "#334155",
        fontSize: "14px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        marginLeft: "10px"
    },
    titleSupport: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        fontSize: "16px",
        fontWeight: 500,
        color: "#ffffff",
        maxWidth: "920px",
        padding: "8px 18px",
        letterSpacing: "0.01em",
        width: "auto",
        textAlign: "center",
        borderRadius: "999px",
        border: "1px solid rgba(255, 255, 255, 0.12)",
        background: 'linear-gradient(135deg, rgba(12, 12, 14, 0.9) 0%, rgba(32, 32, 38, 0.9) 50%, rgba(12, 12, 14, 0.9) 100%), url("/assets/Img/slide3.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.08)"
    },
    titleSupportWrap: {
        display: "flex",
        justifyContent: "center",
        padding: "6px 24px 6px 24px"
    },
    titleSupportAccent: {
        width: "22px",
        height: "1px",
        background: "rgba(255, 255, 255, 0.55)",
        flexShrink: 0
    },
};

const TopMenu = ({ headerVisible: propHeaderVisible, setHeaderVisible: propSetHeaderVisible }) => {
    const navigate = useNavigate();
    const [showHide, setShowHide] = useState(false);
    const [helpShowHide, setHelpShowHide] = useState(false);
    const [issueShowHide, setIssueShowHide] = useState(false);
    const [securityShowHide, setSecurityShowHide] = useState(false);
    const [profileShowHide, setProfileShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [profilePicData, setProfilePicData] = useState(null);
    const [firstLogin, setFirstLogin] = useState(false);
    const [helpDocs, setHelpDocs] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [logoutProcess, setLogoutProcess] = useState(false);
    const [localHeaderVisible, setLocalHeaderVisible] = useState(true);

    const headerVisible = propHeaderVisible !== undefined ? propHeaderVisible : localHeaderVisible;
    const setHeaderVisible = propSetHeaderVisible !== undefined ? propSetHeaderVisible : setLocalHeaderVisible;

    const dropdownRef = useRef(null);

    const pageTitleSelector = useSelector(getPageTitle);
    const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
    const userProfilePicSelector = useSelector(getUserProfilePic);
    const userLoginSelector = useSelector(getloginupdatedstatus);
    const workbenchHelpDocsSelector = useSelector(getWorkbenchHelpDocs);
    const hostDetailsSelector = useSelector(getHostDetails);
    const logoutUserStatusSelector = useSelector(getLogoutUserStatus);
    const loginLogoutUserStatusSelector = useSelector(getLoginLogoutUserStatus);

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        if (currentUser?.id) {
            dispatch(loadUserDetails(currentUser.id));
            dispatch(loadUserProfilePic(currentUser.id));
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.adminDoc));
        }
    }, []);

    useEffect(() => {
        if (workbenchHelpDocsSelector) {
            setHelpDocs(workbenchHelpDocsSelector);
        }
    }, [workbenchHelpDocsSelector]);

    useEffect(() => {
        if (loggedUserDetailsSelector) {
            if (loggedUserDetailsSelector?.maxtasks === null) {
                dispatch(loginStatusUpdate(currentUser.id));
                setFirstLogin(true);
                setSecurityShowHide(true);
            } else {
                setFirstLogin(false);
            }
            setUserDetails(loggedUserDetailsSelector);
        }
    }, [loggedUserDetailsSelector]);

    useEffect(() => {
        if (userProfilePicSelector) {
            setProfilePicData(
                process.env.REACT_APP_API_BASEURL + "/ProfilePics/" + userProfilePicSelector
            );
        }
    }, [userProfilePicSelector]);

    useEffect(() => {
        setLogoutProcess(false);
        if (logoutUserStatusSelector) {
            dispatch(loginLogoutStatusReceived(false));
            window.location = "/login";
        }
        if (loginLogoutUserStatusSelector) {
            dispatch(loginLogoutStatusReceived(false));
            window.location = "/login";
        }
    }, [logoutUserStatusSelector, loginLogoutUserStatusSelector]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleModalShowHide = () => {
        setShowHide((prev) => !prev);
    };

    const handleHelpShowHide = () => {
        setHelpShowHide((prev) => !prev);
    };

    const handleIssueShowHide = () => {
        setIssueShowHide((prev) => !prev);
    };

    const handleSecurityShowHide = () => {
        setSecurityShowHide((prev) => !prev);
        setIsDropdownOpen(false);
    };

    const handleProfileShowHide = () => {
        setProfileShowHide((prev) => !prev);
        setIsDropdownOpen(false);
    };

    const handleLogout = async () => {
        setLogoutProcess(true);
        const hostId = localStorage.getItem("hostId");
        localStorage.removeItem("token");
        if (hostId && currentUser?.id) {
            dispatch(logoutCurrentUser(currentUser.id, hostId));
        } else {
            await PUBLIC_CLIENT_APPLICATION.logoutPopup();
            window.location = "/login";
        }
        localStorage.clear();
        sessionStorage.clear();
        if (currentUser?.id) {
            dispatch(loginLogoutUpdateStatus(currentUser.id));
        }
    };

    const getPortalLabel = () => {
        return "Workbench Portal";
    };

    const getUserDisplayName = () => {
        return currentUser?.name || "Portal User";
    };

    const getRoleLabel = () => {
        return userDetails?.role || "User";
    };

    const getLastLoginLabel = () => {
        return new Date().toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    };

    const handleCurrentTask = async () => { };
    const handleWorkflowTask = () => { };

    const dropdownActionStyle = (isDanger) => ({
        ...HEADER_STYLES.dropdownItem,
        color: isDanger ? "#b91c1c" : "#1e293b"
    });

    const profileImage = profilePicData || "../../assets/img/theme/team-4.png";

    return (
        <>
            <div className="w-100 px-0">
                <div style={HEADER_STYLES.shell} className="col-auto">
                    <div className="align-items-center" style={HEADER_STYLES.topRow}>
                        {headerVisible && (
                            <div className="row pt-2 pb-2" style={{ background: "linear-gradient(270deg, #ffffff 0%, #f8fafc 100%)" }}>
                                <div className="col-lg-7 col-md-12">
                                    <div style={HEADER_STYLES.brandRow}>
                                        <img
                                            src="/assets/Img/logo.png"
                                            alt="Portal logo"
                                            style={HEADER_STYLES.brandLogo}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-5 col-md-12">
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <div ref={dropdownRef} style={HEADER_STYLES.profileCard}>
                                            <div style={HEADER_STYLES.profileMain}>
                                                <img
                                                    alt="Profile"
                                                    src={profileImage}
                                                    style={HEADER_STYLES.avatar}
                                                />
                                                <div style={HEADER_STYLES.userContent}>
                                                    <div style={HEADER_STYLES.userName}>{getUserDisplayName()}</div>
                                                    <div style={HEADER_STYLES.detailRow}>
                                                        <span style={HEADER_STYLES.detailPill}>
                                                            <i className="fa fa-id-badge" aria-hidden="true"></i>
                                                            Reg ID: {currentUser?.id || "-"}
                                                        </span>
                                                        <span style={HEADER_STYLES.detailPill}>
                                                            <i className="fa fa-briefcase" aria-hidden="true"></i>
                                                            Role: {getRoleLabel()}
                                                        </span>
                                                        <span style={HEADER_STYLES.detailPill}>
                                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                            Last Login: {getLastLoginLabel()}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                type="button"
                                                aria-label="Open profile actions"
                                                aria-expanded={isDropdownOpen}
                                                onClick={() => setIsDropdownOpen((prev) => !prev)}
                                                style={HEADER_STYLES.dropdownButton}
                                            >
                                                <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                                            </button>

                                            {isDropdownOpen && (
                                                <div style={HEADER_STYLES.dropdownMenu}>
                                                    <button
                                                        type="button"
                                                        style={dropdownActionStyle(false)}
                                                        onClick={handleProfileShowHide}
                                                    >
                                                        <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                                                        <span>My Profile</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={dropdownActionStyle(false)}
                                                        onClick={() => {
                                                            setIsDropdownOpen(false);
                                                            handleModalShowHide();
                                                        }}
                                                    >
                                                        <i className="fa fa-lock" aria-hidden="true"></i>
                                                        <span>Change Password</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={dropdownActionStyle(false)}
                                                        onClick={handleSecurityShowHide}
                                                    >
                                                        <i className="fa fa-shield" />
                                                        <span>Security Questions</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={dropdownActionStyle(false)}
                                                        onClick={() => {
                                                            setIsDropdownOpen(false);
                                                            handleHelpShowHide();
                                                        }}
                                                    >
                                                        <i className="fa fa-question-circle"></i>
                                                        <span>Help Center</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={dropdownActionStyle(true)}
                                                        onClick={handleLogout}
                                                        disabled={logoutProcess}
                                                    >
                                                        <i className={logoutProcess ? "fa fa-spinner fa-spin" : "ni ni-user-run"} />
                                                        <span>{logoutProcess ? "Signing out..." : "Logout"}</span>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div style={HEADER_STYLES.quickRow} className="row pt-2 pb-2">
                            <div style={HEADER_STYLES.quickInfoBlock} className="col-4">
                                <span style={HEADER_STYLES.portalBadge}>{getPortalLabel()}</span>
                            </div>
                            <div style={HEADER_STYLES.actionWrap} className="col-8">
                                <button
                                    type="button"
                                    onClick={() => navigate("/workplaces")}
                                    style={HEADER_STYLES.quickButton}
                                >
                                    <i className="fa fa-th-large mr-2" aria-hidden="true"></i>
                                    Switch Workplace
                                </button>
                                <button
                                    type="button"
                                    onClick={handleIssueShowHide}
                                    title="Any defects/issues found in the portal can be registered in the customer support portal."
                                    style={HEADER_STYLES.quickButton}
                                >
                                    <i className="fa fa-life-ring mr-2" aria-hidden="true"></i>
                                    Customer Support
                                </button>
                                <button
                                    type="button"
                                    onClick={handleHelpShowHide}
                                    style={HEADER_STYLES.quickButton}
                                >
                                    <i className="fa fa-question-circle mr-2" aria-hidden="true"></i>
                                    Help
                                </button>
                                <button
                                    type="button"
                                    onClick={handleLogout}
                                    disabled={logoutProcess}
                                    style={HEADER_STYLES.logoutButton}
                                >
                                    <i className={logoutProcess ? "fa fa-spinner fa-spin mr-2" : "ni ni-user-run mr-2"} />
                                    {logoutProcess ? "Signing out..." : "Logout"}
                                </button>
                            </div>
                        </div>

                        <div style={HEADER_STYLES.titleSupportWrap} className="row pt-2 pb-2">
                            <div style={HEADER_STYLES.titleSupport} className="col-12">
                                <span>
                                    Human Resources Information Management System (HRIMS) - Onboarding
                                </span>
                            </div>
                            <div className="col-auto d-flex justify-content-end">
                                <button
                                    type="button"
                                    onClick={() => setHeaderVisible(!headerVisible)}
                                    title={headerVisible ? "Hide Header" : "Show Header"}
                                    style={HEADER_STYLES.toggleButton}
                                >
                                    <i className={`fa fa-chevron-${headerVisible ? "up" : "down"}`} aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {showHide && (
                    <ChangePassword
                        handleModalShowHide={handleModalShowHide}
                        showHide={showHide}
                    ></ChangePassword>
                )}
                {profileShowHide && (
                    <PartnerProfile
                        handleProfileShowHide={handleProfileShowHide}
                        profileShowHide={profileShowHide}
                    ></PartnerProfile>
                )}
                {helpShowHide && (
                    <Help
                        helpShowHide={helpShowHide}
                        handleHelpShowHide={handleHelpShowHide}
                        module={pageTitleSelector}
                        helpDocs={helpDocs}
                    ></Help>
                )}
                {issueShowHide && (
                    <SupportPupup
                        handleIssueShowHide={handleIssueShowHide}
                        issueShowHide={issueShowHide}
                        handleCurrentTask={handleCurrentTask}
                        handleWorkflowTask={handleWorkflowTask}
                    ></SupportPupup>
                )}

                {securityShowHide && (
                    <AddSecurityQuestion
                        firstLogin={firstLogin}
                        securityShowHide={securityShowHide}
                        handleSecurityShowHide={handleSecurityShowHide}
                        userDetails={userDetails}
                        handleLogout={handleLogout}
                    ></AddSecurityQuestion>
                )}
            </div>
        </>
    );
};

export default TopMenu;